var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.tagName,
    { tag: "component", class: _vm.currentClass },
    [
      !_vm.hideFirstLastControls
        ? _c(
            _vm.elementTagName,
            {
              key: "first",
              tag: "component",
              class: [
                _vm.itemClass,
                _vm.prevIsDisabled ? _vm.disabledControlClass : _vm.controlClass
              ]
            },
            [
              _c("button", {
                class: [
                  _vm.buttonClass,
                  _vm.prevIsDisabled
                    ? _vm.disabledControlButtonClass
                    : _vm.controlButtonClass
                ],
                attrs: { disabled: _vm.prevIsDisabled },
                domProps: { innerHTML: _vm._s(_vm.firstLabel) },
                on: { click: _vm.goToFirstPage }
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.hidePrevNextControls
        ? _c(
            _vm.elementTagName,
            {
              key: "prev",
              tag: "component",
              class: [
                _vm.itemClass,
                _vm.prevIsDisabled ? _vm.disabledControlClass : _vm.controlClass
              ]
            },
            [
              _c("button", {
                class: [
                  _vm.buttonClass,
                  _vm.prevIsDisabled
                    ? _vm.disabledControlButtonClass
                    : _vm.controlButtonClass
                ],
                attrs: { disabled: _vm.prevIsDisabled },
                domProps: { innerHTML: _vm._s(_vm.prevLabel) },
                on: { click: _vm.goToPrevPage }
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.pageButtons, function(page) {
        return [
          (page === "less" || page === "more"
          ? _vm.ellipsisClass
          : "")
            ? _c(
                _vm.elementTagName,
                {
                  key: page,
                  tag: "component",
                  class: [_vm.itemClass, _vm.ellipsisClass]
                },
                [
                  _c("span", {
                    class: [_vm.buttonClass, _vm.ellipsisButtonClass],
                    domProps: { innerHTML: _vm._s(_vm.ellipsisLabel) }
                  })
                ]
              )
            : _c(
                _vm.elementTagName,
                {
                  key: page,
                  tag: "component",
                  class: [_vm.itemClass, _vm.pageClass]
                },
                [
                  _c(
                    "button",
                    {
                      class: [
                        _vm.buttonClass,
                        _vm.disabled
                          ? _vm.disabledButtonClass
                          : _vm.isPageActive(page)
                          ? _vm.activeButtonClass
                          : _vm.inactiveButtonClass
                      ],
                      attrs: { disabled: _vm.disabled },
                      on: {
                        click: function($event) {
                          return _vm.selectPage(page)
                        }
                      }
                    },
                    [_vm._v("\n        " + _vm._s(page) + "\n      ")]
                  )
                ]
              )
        ]
      }),
      _vm._v(" "),
      !_vm.hidePrevNextControls
        ? _c(
            _vm.elementTagName,
            {
              key: "next",
              tag: "component",
              class: [
                _vm.itemClass,
                _vm.nextIsDisabled ? _vm.disabledControlClass : _vm.controlClass
              ]
            },
            [
              _c("button", {
                class: [
                  _vm.buttonClass,
                  _vm.nextIsDisabled
                    ? _vm.disabledControlButtonClass
                    : _vm.controlButtonClass
                ],
                attrs: { disabled: _vm.nextIsDisabled },
                domProps: { innerHTML: _vm._s(_vm.nextLabel) },
                on: { click: _vm.goToNextPage }
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.hideFirstLastControls
        ? _c(
            _vm.elementTagName,
            {
              key: "last",
              tag: "component",
              class: [
                _vm.itemClass,
                _vm.nextIsDisabled ? _vm.disabledControlClass : _vm.controlClass
              ]
            },
            [
              _c("button", {
                class: [
                  _vm.buttonClass,
                  _vm.nextIsDisabled
                    ? _vm.disabledControlButtonClass
                    : _vm.controlButtonClass
                ],
                attrs: { disabled: _vm.nextIsDisabled },
                domProps: { innerHTML: _vm._s(_vm.lastLabel) },
                on: { click: _vm.goToLastPage }
              })
            ]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }